import styled from 'styled-components';

export const Container = styled.div`
  max-width: 480px;
  width: 100%;
  margin: 0 auto;
  background: #F5F5F5;
  min-height: 100vh;
  padding-bottom: 40px;
`;

export const Header = styled.div`
  position: relative;
  background: white;
  padding: 20px;
  text-align: center;
  border-bottom: 1px solid #E5E5E5;
`;

export const BackButton = styled.button`
  position: absolute;
  left: 20px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #333;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Title = styled.h1`
  font-size: 18px;
  font-weight: bold;
  color: #333;
  margin: 0;
`;

export const Content = styled.div`
  padding: 20px;
`;

export const AlarmCard = styled.div`
  background: white;
  border-radius: 16px;
  padding: 19px;
  margin-bottom: 15px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  position: relative;
`;

export const AlarmHeader = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 3px;
`;

export const AlarmIcon = styled.div`
  font-size: 24px;
  flex-shrink: 0;
  margin-top: -4px;
`;

export const AlarmTitle = styled.div`
  font-size: 16px;
  font-weight: bold;
  color: #333;
  flex: 1;
  text-align: left;
`;

export const AlarmContent = styled.div`
  font-size: 14px;
  color: #666;
  line-height: 1.5;
  margin-left: 36px;
  margin-bottom: 8px;
  text-align: left;
`;

export const AlarmDate = styled.div`
  font-size: 12px;
  color: #999;
  text-align: right;
  margin-top: 8px;
`;

export const GreenText = styled.span`
  color: #1FBC70;
  font-weight: 500;
`;

export const RedText = styled.span`
  color: #FC324A;
  font-weight: 500;
`;

export const EmptyContainer = styled.div`
  padding: 60px 20px;
  text-align: center;
  color: #999;
  font-size: 14px;
`;

export const NewAlarmDivider = styled.div`
  display: flex;
  align-items: center;
  margin: 20px 0;
  gap: 12px;

  &::before,
  &::after {
    content: '';
    flex: 1;
    height: 1px;
    background: #ccc;
  }
`;

export const NewAlarmDividerText = styled.span`
  font-size: 12px;
  color: #999;
  white-space: nowrap;
`;
